export enum MakePaymentAnalyticsMessages {
  capability = 'payments',
  pageLoadedEvent = 'page loaded',
  pageName = 'us foods:r4:make payments',
}
